/* Fig & Bloom wish list (sections/fb-wishlist.liquid).

   Two views on /pages/wishlist:
   - no ?share: the visitor's own list. Hearts save as they go to a list held
     by Birthday Club's owner cookie on this browser; they add a first name and
     birthday, and get a read-only link to hand out. A tap on a picture opens
     a quick view on this page (photographs, title, price, description) and
     does not leave the wish list. The heart button saves a pick.
   - ?share=<token>: a list someone shared. Their picks, their words, and
     "Remember their birthday", which saves a reminder for them (signing in
     with an email code if needed) and links their list to it.

   Everything is built with textContent and element properties, never HTML
   strings, since names and words come from the people who wrote them.

   Unpublished and development themes can open /pages/wishlist?wishlist_mock=1.
   That serves a fixed list in memory and never calls Birthday Club. The live
   theme leaves data-wishlist-mock-allowed empty, so the same URL still uses
   the real API. */
(function (root, factory) {
  var lib = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = lib;
  else if (root.document) lib.start(root.document.getElementById('fb-wishlist'));
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  /* iOS can deliver the select's change 16ms or more after Save's click.
     One window, long enough for that commit, short enough to show an error. */
  var PICKER_COMMIT_MS = 600;
  var dateFieldSeq = 0;

  /* 2000 is a leap year, so 29 February is a real birthday. */
  function validDate(month, day) {
    if (!Number.isInteger(month) || month < 1 || month > 12) return false;
    if (!Number.isInteger(day) || day < 1) return false;
    return day <= new Date(Date.UTC(2000, month, 0)).getUTCDate();
  }
  // A fixed rhythm of crops gives the grid its stagger whatever shape the
  // product photo is, and places every card before images load.
  var RATIOS = [4 / 5, 1, 3 / 4, 1, 5 / 6, 4 / 5, 1, 3 / 4];
  var SHARE_RE = /^[a-f0-9]{32}$/;

  /* Greedy masonry: each card goes to the shortest column, so reading order
     stays close to ranking order across the row. */
  function masonry(items, columns) {
    var out = [], heights = [];
    for (var c = 0; c < columns; c += 1) { out.push([]); heights.push(0); }
    items.forEach(function (item, index) {
      var ratio = RATIOS[index % RATIOS.length];
      var column = heights.indexOf(Math.min.apply(null, heights));
      out[column].push({ item: item, ratio: ratio });
      heights[column] += 1 / ratio + 0.35;
    });
    return out;
  }

  /* Shopify's CDN resizes on request; other hosts pass through. */
  function sizedImage(src, width) {
    try {
      var url = new URL(src);
      if (url.hostname !== 'cdn.shopify.com' && url.pathname.indexOf('/cdn/shop/') !== 0) return src;
      url.searchParams.set('width', String(width));
      return url.href;
    } catch (_) { return src; }
  }

  function price(cents) { return '$' + (Number(cents) / 100).toFixed(2).replace(/\.00$/, ''); }
  function possessive(name) { return /s$/i.test(name) ? name + '’' : name + '’s'; }
  function shareToken(search) {
    var token = new URLSearchParams(search || '').get('share');
    return token && SHARE_RE.test(token) ? token : null;
  }
  /* Only product pages on this storefront. */
  function productHref(path, origin) {
    if (typeof path !== 'string') return null;
    var productPath = /^\/products\/[a-z0-9][a-z0-9-]*$/;
    if (productPath.test(path)) return path;
    try {
      var url = new URL(path);
      var storefrontOrigin = origin || (root.location && root.location.origin);
      if (url.origin === storefrontOrigin && !url.username && !url.password && !url.search && !url.hash && productPath.test(url.pathname)) return url.pathname;
    } catch (_) {}
    return null;
  }
  /* The owner's catalogue names a bouquet by handle, not by a URL. */
  function catalogueHref(item) {
    var handle = item && item.handle;
    return typeof handle === 'string' ? productHref('/products/' + handle) : null;
  }
  /* Storefront product JSON. Only a handle that is already a safe product path. */
  function productJsonPath(item) {
    var path = catalogueHref(item);
    return path ? path + '.js' : null;
  }
  function decodeEntities(text) {
    return text
      .replace(/&#(\d+);/g, function (_, digits) {
        var code = Number(digits);
        return code > 0 && code < 0x110000 ? String.fromCodePoint(code) : '';
      })
      .replace(/&#x([0-9a-f]+);/gi, function (_, hex) {
        var code = parseInt(hex, 16);
        return code > 0 && code < 0x110000 ? String.fromCodePoint(code) : '';
      })
      .replace(/&nbsp;/gi, ' ')
      .replace(/&quot;/gi, '"')
      .replace(/&#0*39;|&apos;/gi, "'")
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&amp;/gi, '&');
  }
  /* The product description is the shop's HTML, including a style block.
     The readable text is what we show; tags are never inserted into the page. */
  function descriptionText(html) {
    if (typeof html !== 'string' || !html) return '';
    var text = html
      .replace(/<style[\s\S]*?<\/style>/gi, '')
      .replace(/<script[\s\S]*?<\/script>/gi, '')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/(p|div|h[1-6]|li|ul|ol|tr|blockquote)>/gi, '\n')
      .replace(/<li[^>]*>/gi, '• ');
    text = decodeEntities(text.replace(/<[^>]+>/g, ''));
    return text.split('\n').map(function (line) { return line.replace(/[ \t]+/g, ' ').trim(); }).filter(Boolean).join('\n');
  }
  function productImageUrl(src) {
    if (typeof src !== 'string' || !src) return null;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return /^https:\/\/cdn\.shopify\.com\//.test(src) ? src : null;
  }
  /* Photographs, title, price and description from /products/<handle>.js.
     A payload for a different handle is refused. */
  function productDetails(data, handle) {
    if (!data || typeof data !== 'object' || Array.isArray(data)) return null;
    if (typeof data.handle === 'string' && data.handle !== handle) return null;
    var title = typeof data.title === 'string' ? data.title : '';
    var images = [];
    function addImage(src, alt) {
      var safe = productImageUrl(src);
      if (!safe || images.length >= 12) return;
      images.push({ src: safe, alt: typeof alt === 'string' && alt ? alt : title });
    }
    var media = Array.isArray(data.media) ? data.media : [];
    media.forEach(function (entry) {
      if (!entry || (entry.media_type && entry.media_type !== 'image')) return;
      addImage(entry.src || (entry.preview_image && entry.preview_image.src), entry.alt);
    });
    if (!images.length && Array.isArray(data.images)) data.images.forEach(function (src) { addImage(src, title); });
    var cents = Number(data.price_min != null ? data.price_min : data.price);
    return {
      title: title,
      priceLabel: isFinite(cents) ? (data.price_varies ? 'From ' : '') + price(cents) : '',
      description: descriptionText(typeof data.description === 'string' ? data.description : ''),
      images: images
    };
  }

  // Only the API's own words reach the page; a network failure or a reply
  // that isn't ours ("Request failed", "Failed to fetch") gets the fallback.
  function storefrontShareUrl(value) {
    try { var url = new URL(value, 'https://figandbloom.com'); var token = url.searchParams.get('share'); return SHARE_RE.test(token || '') ? 'https://figandbloom.com/pages/wishlist?share=' + token : null; } catch (_) { return null; }
  }

  function errorText(cause, fallback) {
    var said = cause && cause.payload && cause.payload.error && cause.payload.error.message;
    return typeof said === 'string' && said ? said : fallback;
  }

  /* Preview and the theme editor only. The live theme's attribute is empty,
     and an empty allowance ignores both the query and any stored flag. */
  var MOCK_STORAGE_KEY = 'fb_wishlist_mock';
  function mockStore() {
    try { return root.sessionStorage || null; } catch (_) { return null; }
  }
  function wishlistMockEnabled(page) {
    if (!page || page.getAttribute('data-wishlist-mock-allowed') !== '1') return false;
    var query = null;
    try { query = new root.URLSearchParams(root.location.search).get('wishlist_mock'); } catch (_) { query = null; }
    var store = mockStore();
    if (query === '1') {
      try { if (store) store.setItem(MOCK_STORAGE_KEY, '1'); } catch (_) {}
      return true;
    }
    if (query === '0') {
      try { if (store) store.removeItem(MOCK_STORAGE_KEY); } catch (_) {}
      return false;
    }
    try { return !!(store && store.getItem(MOCK_STORAGE_KEY) === '1'); } catch (_) { return false; }
  }

  /* A fixed range, held in memory. Product JSON at /products/<handle>.js is
     still a public storefront read. Nothing here calls Birthday Club. */
  function wishlistMockApi(page) {
    var catalogueItems = [
      { handle: 'osaka', title: 'Osaka', image: '', imageAlt: 'Osaka Bouquet', priceCents: 15900, category: 'Flowers' },
      { handle: 'marseille', title: 'Marseille', image: '', imageAlt: 'Marseille Bouquet', priceCents: 18900, category: 'Flowers' },
      { handle: 'monaco-bouquet-pink', title: 'Monaco', image: '', imageAlt: 'Monaco Bouquet', priceCents: 12900, category: 'Flowers' }
    ];
    var list = {
      picks: [{ handle: 'osaka' }, { handle: 'marseille' }],
      items: [
        { handle: 'osaka', title: 'Osaka', intention: 'favourite', status: 'active', version: 1 },
        { handle: 'marseille', title: 'Marseille', intention: 'wish', status: 'active', version: 1 }
      ],
      notes: null,
      name: null,
      birthday: null,
      shareUrl: null,
      kept: null,
      sharedWith: [],
      notesVersion: null
    };
    var preferences = { revision: 1, facts: [], notesText: '', notesVersion: null };
    root.__fbWishlistMockLog = [];

    function logPatch(body) {
      var recorded = {};
      Object.keys(body || {}).forEach(function (key) { recorded[key] = body[key]; });
      root.__fbWishlistMockLog.push({ method: 'PATCH', path: '/wishlist/me', body: recorded });
      page.setAttribute('data-wishlist-mock-last', JSON.stringify(recorded));
    }

    async function request(path, options) {
      var method = (options && options.method) || 'GET';
      var body = options && options.body || {};
      if (path === '/wishlist/catalogue' && method === 'GET') {
        return { items: catalogueItems, categories: [{ key: 'Flowers', label: 'Flowers' }] };
      }
      if (path === '/wishlist/me' && method === 'GET') return { list: list };
      if (path === '/wishlist/me' && method === 'PATCH') {
        list.name = body.name;
        list.notes = body.about;
        list.birthday = body.month || body.day ? { month: body.month, day: body.day } : null;
        logPatch(body);
        return { list: list };
      }
      if (path === '/wishlist/me/items' && method === 'POST') {
        var known = null;
        catalogueItems.forEach(function (item) { if (item.handle === body.handle) known = item; });
        var row = null;
        list.items.forEach(function (item) { if (item.handle === body.handle) row = item; });
        var version = (body.expectedVersion || 0) + 1;
        if (!row) {
          row = { handle: body.handle, title: known ? known.title : body.handle, intention: body.intention, status: body.status, version: version };
          list.items.push(row);
        } else {
          row.intention = body.intention;
          row.status = body.status;
          row.version = version;
        }
        list.picks = list.items.filter(function (item) { return item.status === 'active'; }).map(function (item) { return { handle: item.handle }; });
        return { saved: true, version: version };
      }
      if (path === '/wishlist/me/share' && method === 'POST') {
        list.shareUrl = 'https://figandbloom.com/pages/wishlist?share=' + 'ab'.repeat(16);
        return { shareUrl: list.shareUrl };
      }
      if (path === '/wishlist/me/preferences' && method === 'GET') {
        preferences.notesText = list.notes || '';
        preferences.notesVersion = list.notesVersion;
        return { preferences: preferences };
      }
      if (path === '/wishlist/me/preferences' && method === 'PATCH') {
        preferences.revision += 1;
        return { preferences: preferences };
      }
      var shared = /^\/wishlist\/shared\/([a-f0-9]{32})$/.exec(path);
      if (shared && method === 'GET') {
        return {
          name: 'Sam',
          notes: null,
          birthday: null,
          remembered: null,
          products: catalogueItems.map(function (item) { return Object.assign({ url: '/products/' + item.handle }, item); })
        };
      }
      if (/^\/wishlist\/shared\/[a-f0-9]{32}\/add$/.test(path) && method === 'POST') return { ok: true };
      var error = new Error('Preview mock has no reply for ' + method + ' ' + path);
      error.code = 'MOCK';
      throw error;
    }

    return {
      request: request,
      me: async function () { return { signedIn: true }; },
      clearMe: function () {},
      createOccasion: async function (draft) {
        return { occasion: { id: 'mock-occasion', friendId: 'mock-friend', name: draft && draft.name, month: draft && draft.month, day: draft && draft.day } };
      },
      requestEmailCode: async function () { return { ok: true }; },
      verifyEmailCode: async function () { return { saved: [] }; }
    };
  }

  function start(page) {
    if (!page) return;
    var mock = wishlistMockEnabled(page);
    if (!mock && !root.FBRemindersAPI) return;
    var doc = root.document;
    var api = mock ? wishlistMockApi(page) : root.FBRemindersAPI.create(page.dataset.apiBase);
    var mount = page.querySelector('[data-wishlist-root]');
    var viewGeneration = 0, disposeOwnerView = null;
    var hero = page.querySelector('[data-wishlist-hero]');
    var back = page.querySelector('[data-wishlist-reminders-back]');
    if (back) back.hidden = !/^reminders(?:-|$)/.test(new root.URLSearchParams(root.location.search).get('via') || '');

    function el(tag, className, text) {
      var node = doc.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined && text !== null) node.textContent = text;
      return node;
    }
    function button(text, className, onClick) {
      var node = el('button', className || 'fb-wishlist__button', text);
      node.type = 'button';
      if (onClick) node.addEventListener('click', onClick);
      return node;
    }
    function field(labelText, input) {
      var label = el('label', 'fb-wishlist__field');
      label.appendChild(el('span', '', labelText));
      label.appendChild(input);
      return label;
    }
    function input(type, value, attrs) {
      var node = el('input', 'fb-wishlist__input');
      node.type = type;
      node.value = value || '';
      Object.keys(attrs || {}).forEach(function (key) { node.setAttribute(key, attrs[key]); });
      return node;
    }
    /* Day text field plus a month <select>. iPhone Safari can fire Save's
       click before the select's change, and that change can land 16ms or
       more later. While the picker is open and has not committed, Save waits
       up to PICKER_COMMIT_MS for change or input, then stores that value
       once. A date that is already valid and committed still saves inside
       the click, so Save is disabled before the handler returns. Nothing is
       stored as month 0 or as January. The error waits until the window
       ends, and a valid edit clears the field error. */
    function birthdayText(birthday, numberKey, textKey) {
      if (!birthday) return '';
      if (Object.prototype.hasOwnProperty.call(birthday, textKey) && birthday[textKey] != null) return String(birthday[textKey]);
      return birthday[numberKey] ? String(birthday[numberKey]) : '';
    }
    function birthdayInputs(birthday) {
      var day = input('text', birthdayText(birthday, 'day', 'dayText'), { inputmode: 'numeric', maxlength: '2', autocomplete: 'bday-day' });
      day.setAttribute('data-wishlist-day', '');
      var month = el('select', 'fb-wishlist__input');
      month.setAttribute('data-wishlist-month', '');
      month.setAttribute('autocomplete', 'bday-month');
      month.appendChild(new Option('Month', ''));
      MONTHS.forEach(function (name, index) { month.appendChild(new Option(name, String(index + 1))); });
      month.value = birthdayText(birthday, 'month', 'monthText');
      var error = el('p', 'fb-wishlist__message');
      error.id = 'fb-wishlist-date-error-' + (++dateFieldSeq);
      error.setAttribute('data-wishlist-month-error', '');
      error.hidden = true;
      day.setAttribute('aria-describedby', error.id);
      month.setAttribute('aria-describedby', error.id);
      var row = el('div', 'fb-wishlist__row');
      row.appendChild(field('Day', day));
      row.appendChild(field('Month', month));
      var wrap = el('div', 'fb-wishlist__date');
      wrap.appendChild(row);
      wrap.appendChild(error);

      function monthText() { return month.value == null ? '' : String(month.value).trim(); }
      function dayText() { return String(day.value || '').trim(); }
      function parse() {
        var dayValue = dayText(), monthValue = monthText();
        if (!dayValue && !monthValue) return { ok: true, month: null, day: null };
        if (!/^\d{1,2}$/.test(monthValue) || !/^\d{1,2}$/.test(dayValue)) return { ok: false };
        var monthNumber = Number(monthValue), dayNumber = Number(dayValue);
        if (!validDate(monthNumber, dayNumber)) return { ok: false };
        return { ok: true, month: monthNumber, day: dayNumber };
      }
      function clearError() {
        error.textContent = '';
        error.hidden = true;
        error.removeAttribute('role');
        month.removeAttribute('aria-invalid');
        day.removeAttribute('aria-invalid');
      }
      function showError() {
        var monthBad = !/^\d{1,2}$/.test(monthText()) || Number(monthText()) < 1 || Number(monthText()) > 12;
        error.hidden = false;
        error.setAttribute('role', 'alert');
        error.textContent = monthBad ? 'Choose a month.' : 'Check the day and month.';
        if (monthBad) {
          month.setAttribute('aria-invalid', 'true');
          day.removeAttribute('aria-invalid');
          if (month.focus) month.focus();
        } else {
          month.removeAttribute('aria-invalid');
          day.setAttribute('aria-invalid', 'true');
          if (day.focus) day.focus();
        }
      }

      var token = 0, armed = false, pending = null, timer = 0, listening = false;
      var pendingCommit = false, openedMonth = '', openedDay = '';
      function markPending() { pendingCommit = true; }
      function markCommitted() { pendingCommit = false; if (parse().ok) clearError(); }
      month.addEventListener('focus', markPending);
      month.addEventListener('change', markCommitted);
      month.addEventListener('input', markCommitted);
      day.addEventListener('change', markCommitted);
      day.addEventListener('input', markCommitted);
      function onPickerEvent() {
        if (!armed) return;
        if (monthText() === openedMonth && dayText() === openedDay) return;
        var date = parse();
        if (!date.ok) return;
        /* After this event finishes bubbling, so the draft hears the same
           change before the save reads it. Still before the commit window. */
        var mine = token;
        var run = function () {
          if (mine !== token || !armed) return;
          var latest = parse();
          if (!latest.ok) return;
          settle(latest);
        };
        if (root.queueMicrotask) root.queueMicrotask(run);
        else Promise.resolve().then(run);
      }
      function bindPicker() {
        if (listening) return;
        listening = true;
        month.addEventListener('change', onPickerEvent);
        month.addEventListener('input', onPickerEvent);
        day.addEventListener('change', onPickerEvent);
        day.addEventListener('input', onPickerEvent);
      }
      function unbindPicker() {
        if (!listening) return;
        listening = false;
        month.removeEventListener('change', onPickerEvent);
        month.removeEventListener('input', onPickerEvent);
        day.removeEventListener('change', onPickerEvent);
        day.removeEventListener('input', onPickerEvent);
      }
      function settle(date) {
        if (!armed) return;
        armed = false;
        pendingCommit = false;
        root.clearTimeout(timer);
        timer = 0;
        unbindPicker();
        var done = pending;
        pending = null;
        if (!date.ok) { showError(); if (done) done(date); return; }
        clearError();
        if (done) done(date);
      }
      /* An open picker has not committed. Wait for its change or input, and
         save on that event. The same tap must not also save when the timer
         ends. A committed valid date does not enter this wait. */
      function commit(done) {
        var mine = ++token;
        armed = true;
        pending = done;
        root.clearTimeout(timer);
        timer = 0;
        if (!pendingCommit) { settle(parse()); return; }
        openedMonth = monthText();
        openedDay = dayText();
        bindPicker();
        timer = root.setTimeout(function () {
          if (mine !== token || !armed) return;
          settle(parse());
        }, PICKER_COMMIT_MS);
      }

      return {
        row: wrap,
        value: function () {
          var date = parse();
          return {
            month: date.ok ? date.month : null,
            day: date.ok ? date.day : null,
            monthText: monthText(),
            dayText: dayText()
          };
        },
        commit: commit
      };
    }
    function columns() {
      var wide = root.matchMedia && root.matchMedia('(min-width: 990px)').matches;
      var medium = root.matchMedia && root.matchMedia('(min-width: 600px)').matches;
      return wide ? 4 : medium ? 3 : 2;
    }
    function message(text) {
      var node = el('p', 'fb-wishlist__message', text || '');
      node.setAttribute('role', 'status');
      return node;
    }
    if (mock) {
      var mockBanner = el('p', 'fb-wishlist__mock', 'Preview mock — nothing is saved');
      mockBanner.setAttribute('data-wishlist-mock-banner', '');
      mockBanner.setAttribute('role', 'status');
      if (hero) page.insertBefore(mockBanner, hero);
      else page.appendChild(mockBanner);
    }

    /* ---------- a card in the grid ---------- */
    function card(item, ratio, options) {
      var figure = el('figure', 'fb-wishlist__card');
      figure.setAttribute('role', 'listitem');
      var media = el(options.href ? 'a' : options.onOpen ? 'button' : 'div', 'fb-wishlist__media');
      if (options.href) media.href = options.href;
      if (options.onOpen) {
        media.type = 'button';
        media.setAttribute('aria-haspopup', 'dialog');
        media.setAttribute('aria-label', 'See ' + item.title);
        media.setAttribute('data-wishlist-handle', item.handle);
        media.addEventListener('click', function () { options.onOpen(item, media); });
      }
      media.style.aspectRatio = String(ratio);
      var image = el('img');
      image.src = sizedImage(item.image, 480);
      image.srcset = [240, 360, 480, 720].map(function (w) { return sizedImage(item.image, w) + ' ' + w + 'w'; }).join(', ');
      image.sizes = '(min-width: 990px) 260px, (min-width: 600px) 33vw, 50vw';
      image.alt = item.imageAlt || item.title;
      image.loading = 'lazy';
      image.decoding = 'async';
      media.appendChild(image);
      var frame = el('div', 'fb-wishlist__frame');
      frame.appendChild(media);
      figure.appendChild(frame);
      if (options.onToggle) {
        var heart = button('', 'fb-wishlist__heart', function () { options.onToggle(item, heart.getAttribute('aria-pressed') !== 'true'); });
        heart.setAttribute('aria-label', 'Love ' + item.title);
        heart.setAttribute('aria-pressed', options.loved ? 'true' : 'false');
        heart.appendChild(heartIcon());
        frame.appendChild(heart);
        /* No double-tap heart. A second tap must not also save a pick: the
           first tap opens the quick view, and the heart button is the control. */
      }
      var caption = el('figcaption', 'fb-wishlist__caption');
      caption.appendChild(el('span', 'fb-wishlist__name', item.title));
      caption.appendChild(el('span', 'fb-wishlist__price', 'From ' + price(item.priceCents)));
      if (options.savedItems && root.FBWishlistIntent) {
        var saved = options.savedItems.find(function (row) { return row.handle === item.handle && row.status === 'active'; });
        if (saved) caption.appendChild(root.FBWishlistIntent.controls(doc, saved, options.onIntent, false, options.intentDisabled));
      } else if (item.intention || item.evidence) caption.appendChild(el('span', 'fb-wishlist__hint', item.intention === 'wish' || item.evidence && item.evidence.kind === 'recipient_wishlist' ? 'Wish · something they’d like as a gift' : 'Favourite · something they like'));
      figure.appendChild(caption);
      return figure;
    }
    function heartIcon() {
      var ns = 'http://www.w3.org/2000/svg';
      var svg = doc.createElementNS(ns, 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('width', '22');
      svg.setAttribute('height', '22');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      var path = doc.createElementNS(ns, 'path');
      path.setAttribute('d', 'M12 20.7c-.35 0-.7-.12-.98-.36C7 17.06 3.4 13.9 3.4 10.2c0-2.6 2-4.7 4.5-4.7 1.55 0 3 .76 3.85 2l.25.36.25-.36a4.68 4.68 0 0 1 3.85-2c2.5 0 4.5 2.1 4.5 4.7 0 3.7-3.6 6.86-7.62 10.14-.28.24-.63.36-.98.36Z');
      path.setAttribute('stroke-width', '1.6');
      path.setAttribute('stroke-linejoin', 'round');
      svg.appendChild(path);
      return svg;
    }
    function closeIcon() {
      var ns = 'http://www.w3.org/2000/svg';
      var svg = doc.createElementNS(ns, 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('width', '22');
      svg.setAttribute('height', '22');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      var path = doc.createElementNS(ns, 'path');
      path.setAttribute('d', 'M6 6 L18 18 M18 6 L6 18');
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.8');
      path.setAttribute('stroke-linecap', 'round');
      svg.appendChild(path);
      return svg;
    }
    function grid(items, label, options) {
      var wrap = el('div', 'fb-wishlist__grid');
      wrap.setAttribute('role', 'list');
      wrap.setAttribute('aria-label', label);
      masonry(items, columns()).forEach(function (column) {
        var col = el('div', 'fb-wishlist__column');
        col.setAttribute('role', 'none');
        column.forEach(function (entry) {
          col.appendChild(card(entry.item, entry.ratio, {
            loved: options.loved && options.loved.has(entry.item.handle),
            onToggle: options.onToggle,
            href: options.href ? options.href(entry.item) : null,
            onOpen: options.onOpen && productJsonPath(entry.item) ? options.onOpen : null,
            savedItems: options.savedItems, onIntent: options.onIntent, intentDisabled: options.intentDisabled
          }));
        });
        wrap.appendChild(col);
      });
      return wrap;
    }

    /* ---------- the visitor's own list ---------- */
    async function ownerView() {
      var generation = ++viewGeneration;
      if (disposeOwnerView) { disposeOwnerView(); disposeOwnerView = null; }
      function live() { return generation === viewGeneration; }
      var viewApi = Object.assign({}, api, { request: async function (path, options) {
        if (!live()) throw new Error('Stale wish list view');
        var reply = await api.request(path, options);
        if (!live()) throw new Error('Stale wish list view');
        return reply;
      } });
      mount.textContent = '';
      mount.appendChild(message('Loading your wish list…'));
      var catalogue, list;
      try {
        var results = await Promise.all([viewApi.request('/wishlist/catalogue'), viewApi.request('/wishlist/me')]);
        catalogue = results[0];
        list = results[1].list;
      } catch (cause) {
        if (!live()) return;
        mount.textContent = '';
        mount.appendChild(message(errorText(cause, 'The range is unavailable just now. Try again shortly.')));
        return;
      }
      var state = {
        tab: list && (list.picks || []).length ? 'list' : 'browse', category: null,
        items: list && list.items || (list && list.picks || []).map(function (p) { return Object.assign({ intention: 'favourite', status: 'active', version: 0 }, p); }),
        loved: new Set((list && list.picks || []).map(function (pick) { return pick.handle; })),
        list: list || { picks: [], notes: null, name: null, birthday: null, shareUrl: null, kept: null, sharedWith: [] },
        status: ''
      };
      var byHandle = new Map(catalogue.items.map(function (item) { return [item.handle, item]; }));
      if (list) {
        hero.querySelector('.fb-wishlist__title').textContent = 'Your wish list.';
        hero.querySelector('.fb-wishlist__lead').textContent = 'Change it whenever you like. The people you’ve shared it with see the latest version.';
      }

      var intent = root.FBWishlistIntent && root.FBWishlistIntent.controller(viewApi, '/wishlist/me/items', state.items);
      async function changeIntent(item, intention, status) {
        if (!live() || !intent || state.intentBusy || state.intentConflict) return;
        state.intentBusy = true; state.status = 'Saving…'; render();
        try {
          await intent.change(item, intention, status);
          state.items = intent.items();
          state.list.items = state.items;
          state.loved = new Set(state.items.filter(function (row) { return row.status === 'active'; }).map(function (row) { return row.handle; }));
          state.status = 'Saved.'; state.intentDraft = null;
        } catch (cause) {
          state.intentDraft = item.title + ': ' + (status === 'fulfilled' ? 'Mark received' : status === 'withdrawn' ? 'Remove' : intention === 'wish' ? 'Add to wishes' : 'Keep as favourite');
          state.intentConflict = true;
          state.status = errorText(cause, 'We couldn’t save that. Your choice is still here.');
        } finally { state.intentBusy = false; render(); }
      }
      async function reloadItems() {
        if (!live() || state.intentBusy) return;
        state.intentBusy = true; render();
        try {
          state.items = await intent.reload();
          state.list.items = state.items;
          state.loved = new Set(state.items.filter(function (row) { return row.status === 'active'; }).map(function (row) { return row.handle; }));
          state.intentConflict = false; state.status = 'Latest list loaded. Review your earlier choice before trying again.';
        } catch (_) { state.status = 'We couldn’t reload your list. Your earlier choice is still here.'; }
        finally { state.intentBusy = false; render(); }
      }
      async function toggle(item, loved) {
        var stored = state.items.find(function (row) { return row.handle === item.handle; }) || Object.assign({}, item, { intention: 'favourite', status: 'withdrawn', version: 0 });
        return changeIntent(stored, loved ? stored.status === 'active' ? stored.intention : 'favourite' : stored.intention, loved ? 'active' : 'withdrawn');
      }

      function tabs() {
        var nav = el('nav', 'fb-wishlist__tabs');
        nav.setAttribute('aria-label', 'Your wish list');
        [['browse', 'Browse'], ['list', 'Your list']].forEach(function (pair) {
          var tab = button(pair[1], 'fb-wishlist__tab', function () { state.tab = pair[0]; state.status = ''; render(); nav.scrollIntoView({ block: 'start' }); });
          if (state.tab === pair[0]) tab.setAttribute('aria-current', 'page');
          if (pair[0] === 'list' && state.loved.size) tab.appendChild(el('span', 'fb-wishlist__count', String(state.loved.size)));
          nav.appendChild(tab);
        });
        return nav;
      }

      function browse() {
        var section = el('section', 'fb-wishlist__section');
        section.appendChild(el('p', 'fb-wishlist__hint', 'Tap a picture to read about a bouquet. Tap the heart to save something you like. Add it to wishes if you’d like it as a gift. Every heart saves as you go.'));
        var pills = el('div', 'fb-wishlist__pills');
        pills.setAttribute('role', 'group');
        pills.setAttribute('aria-label', 'Filter by category');
        [{ key: null, label: 'Everything' }].concat(catalogue.categories).forEach(function (option) {
          var pill = button(option.label, 'fb-wishlist__pill', function () { state.category = option.key; render(); });
          pill.setAttribute('aria-pressed', state.category === option.key ? 'true' : 'false');
          pills.appendChild(pill);
        });
        section.appendChild(pills);
        var shown = catalogue.items.filter(function (item) { return !state.category || item.category === state.category; });
        section.appendChild(grid(shown, 'Gifts', { loved: state.loved, onToggle: toggle, onOpen: openQuickView, savedItems: state.items, onIntent: changeIntent, intentDisabled: state.intentBusy || state.intentConflict }));
        return section;
      }

      function yourList() {
        var section = el('section', 'fb-wishlist__section');
        var loved = Array.from(state.loved).map(function (handle) { return byHandle.get(handle); }).filter(Boolean);
        var retired = state.items.filter(function (item) { return item.status === 'active' && !byHandle.has(item.handle); });
        if (!loved.length && !retired.length) section.appendChild(el('p', 'fb-wishlist__hint', 'Nothing loved yet. Tap the heart to save something you like. Add it to wishes if you’d like it as a gift.'));
        else if (loved.length) section.appendChild(grid(loved.sort(function (a, b) { var ai = state.items.find(function (r) { return r.handle === a.handle; }), bi = state.items.find(function (r) { return r.handle === b.handle; }); return Number(bi && bi.intention === 'wish') - Number(ai && ai.intention === 'wish'); }), 'Your wishes and favourites', { loved: state.loved, onToggle: toggle, onOpen: openQuickView, savedItems: state.items, onIntent: changeIntent, intentDisabled: state.intentBusy || state.intentConflict }));

        retired.forEach(function (item) {
          var card = el('div', 'fb-wishlist__panel'); card.appendChild(el('h3', '', item.title));
          card.appendChild(el('p', 'fb-wishlist__hint', 'No longer in the range'));
          if (root.FBWishlistIntent) card.appendChild(root.FBWishlistIntent.controls(doc, item, changeIntent, false, state.intentBusy || state.intentConflict));
          section.appendChild(card);
        });
        var closed = state.items.filter(function (row) { return row.status !== 'active'; });
        if (closed.length && root.FBWishlistIntent) {
          var history = el('details', 'fb-wishlist__panel'); history.appendChild(el('summary', '', 'Received and removed items'));
          closed.forEach(function (row) { history.appendChild(el('h3', '', row.title)); history.appendChild(root.FBWishlistIntent.controls(doc, row, changeIntent, false, state.intentBusy || state.intentConflict)); }); section.appendChild(history);
        }
        var about = el('details', 'fb-wishlist__panel ph-mask ph-no-capture'); about.open = !!state.detailsConflict || !!state.aboutOpen; about.setAttribute('data-wishlist-about', '');
        about.appendChild(el('summary', '', 'Your name, birthday and original note'));
        about.appendChild(el('h2', 'fb-wishlist__heading', 'About you'));
        about.appendChild(el('p', 'fb-wishlist__hint', 'Your first name tells people whose list it is. Your birthday means their reminder is right from the start.'));
        if (state.detailsSavedKey == null && state.list.birthday) {
          state.detailsSavedKey = JSON.stringify([state.list.name || '', state.list.notes || '', state.list.birthday.month, state.list.birthday.day]);
        }
        var draft = state.detailsDraft || state.list;
        var name = input('text', draft.name, { autocomplete: 'given-name', maxlength: '40' });
        about.appendChild(field('First name', name));
        var birthday = birthdayInputs(draft.birthday);
        about.appendChild(birthday.row);
        var notes = el('textarea', 'fb-wishlist__input');
        notes.maxLength = 500;
        notes.rows = 3;
        notes.value = draft.notes || '';
        notes.placeholder = 'Colours you love, scents you don’t, allergies.';
        about.appendChild(field('Anything else we should know?', notes));
        function rememberDraft() {
          var date = birthday.value();
          var birthdayDraft = (date.dayText || date.monthText || date.month || date.day) ? date : null;
          state.detailsDraft = { name: name.value, notes: notes.value, birthday: birthdayDraft, notesVersion: state.detailsDraft ? state.detailsDraft.notesVersion : state.list.notesVersion };
          state.detailsRevision = (state.detailsRevision || 0) + 1;
        }
        about.addEventListener('input', rememberDraft);
        about.addEventListener('change', rememberDraft);
        var saved = message(state.detailsStatus || '');
        saved.setAttribute('data-wishlist-details-status', '');
        function showSaveState() {
          if (!live()) return;
          var visibleSave = mount.querySelector('[data-wishlist-save-details]');
          var visibleStatus = mount.querySelector('[data-wishlist-details-status]');
          if (visibleSave) visibleSave.disabled = !!state.savingDetails || !!state.detailsConflict;
          if (visibleStatus) visibleStatus.textContent = state.detailsStatus || '';
        }
        function saveDetailsDate(date) {
          if (!live() || state.savingDetails || state.detailsConflict) return;
          if (!date.ok) { state.detailsStatus = ''; showSaveState(); return; }
          var savedKey = JSON.stringify([name.value, notes.value, date.month, date.day]);
          if (state.detailsSavedKey === savedKey) return;
          rememberDraft();
          var revision = state.detailsRevision;
          state.savingDetails = true;
          state.detailsStatus = 'Saving…';
          showSaveState();
          var noteBody = { name: name.value, about: notes.value, month: date.month, day: date.day };
          if (state.detailsDraft.notesVersion != null) noteBody.expectedNotesVersion = state.detailsDraft.notesVersion;
          (async function () {
            try {
              var response = await viewApi.request('/wishlist/me', { method: 'PATCH', body: noteBody });
              state.list = response.list;
              state.detailsSavedKey = savedKey;
              if (live() && state.preferenceUI) state.preferenceUI.refresh();
              if (revision === state.detailsRevision) state.detailsDraft = null;
              else if (state.detailsDraft) state.detailsDraft.notesVersion = response.list.notesVersion;
              state.detailsStatus = revision === state.detailsRevision ? 'Saved.' : 'Saved. Your newer changes still need saving.';
            } catch (cause) { state.detailsStatus = errorText(cause, 'We couldn’t save that. Try again.'); state.detailsConflict = cause && cause.status === 409; if (live() && state.preferenceUI) state.preferenceUI.refresh(); }
            finally { state.savingDetails = false; if (state.detailsConflict) render(); else showSaveState(); }
          })();
        }
        var saveDetails = button('Save note and details', 'fb-wishlist__button', function () {
          if (!live() || state.savingDetails || state.detailsConflict) return;
          birthday.commit(saveDetailsDate);
        });
        saveDetails.setAttribute('data-wishlist-save-details', '');
        saveDetails.disabled = !!state.savingDetails || !!state.detailsConflict;
        about.appendChild(saveDetails);
        about.appendChild(saved);
        if (state.detailsConflict) {
          if (state.latestDetails) {
            about.appendChild(el('p', 'fb-wishlist__hint', 'Latest saved note: ' + (state.latestDetails.notes || '')));
            about.appendChild(button('Edit latest note', 'fb-wishlist__button', function () { state.previousNoteDraft = state.detailsDraft.notes; state.list = state.latestDetails; state.detailsDraft = Object.assign({}, state.latestDetails); state.latestDetails = null; state.detailsConflict = false; render(); }));
          } else about.appendChild(button('Compare with latest note', 'fb-wishlist__button', async function () {
            if (!live() || state.comparingDetails) return; state.comparingDetails = true;
            try { var response = await viewApi.request('/wishlist/me'); state.latestDetails = response.list; render(); } catch (_) { state.detailsStatus = 'We couldn’t load the latest note. Your draft is still here.'; showSaveState(); } finally { state.comparingDetails = false; }
          }));
        }
        if (state.previousNoteDraft) { var previous = el('details'); previous.appendChild(el('summary', '', 'Your previous note draft')); previous.appendChild(el('p', '', state.previousNoteDraft)); about.appendChild(previous); }
        section.appendChild(about);
        if (root.FBPersonPreferences && state.list.items) {
          if (!state.preferenceMount) state.preferenceMount = el('div');
          section.appendChild(state.preferenceMount);
        }

        state.list.shareUrl = storefrontShareUrl(state.list.shareUrl);
        var sharing = el('div', 'fb-wishlist__panel');
        sharing.appendChild(el('h2', 'fb-wishlist__heading', 'Share your list'));
        sharing.appendChild(el('p', 'fb-wishlist__hint', 'Anyone with your link can see your picks and add your birthday to their reminders. Only you can change your list.'));
        var linkBox = input('url', state.list.shareUrl || '', { readonly: 'readonly', 'aria-label': 'Your share link' });
        linkBox.hidden = !state.list.shareUrl;
        sharing.appendChild(linkBox);
        var shareStatus = message('');
        var shareButton = sharing.appendChild(button(state.list.shareUrl ? 'Copy my link' : 'Get my link', 'fb-wishlist__button', async function () {
          try {
            if (!state.list.shareUrl) {
              var response = await viewApi.request('/wishlist/me/share', { method: 'POST', body: {} });
              state.list.shareUrl = storefrontShareUrl(response.shareUrl);
              if (!state.list.shareUrl) throw new Error('Invalid share link');
              linkBox.value = state.list.shareUrl;
              linkBox.hidden = false;
              shareButton.textContent = 'Copy my link';
            }
            if (root.navigator.share) {
              await root.navigator.share({ title: 'My wish list', url: state.list.shareUrl }).catch(function () {});
              shareStatus.textContent = '';
            } else if (root.navigator.clipboard) {
              await root.navigator.clipboard.writeText(state.list.shareUrl);
              shareStatus.textContent = 'Link copied.';
            } else { linkBox.select(); shareStatus.textContent = 'Select and copy your link.'; }
          } catch (cause) { shareStatus.textContent = errorText(cause, 'We couldn’t make your link. Try again.'); }
        }));
        sharing.appendChild(shareStatus);
        if (state.list.sharedWith && state.list.sharedWith.length) {
          sharing.appendChild(el('p', 'fb-wishlist__hint', 'Shared with ' + state.list.sharedWith.join(', ') + '.'));
        }
        section.appendChild(sharing);

        var keep = el('p', 'fb-wishlist__hint');
        if (state.list.kept) keep.textContent = 'Kept with ' + state.list.kept + '. ';
        var manage = el('a', '', 'Keep or recover your list with mobile or email');
        manage.href = '/pages/wishlist?recover=1';
        keep.appendChild(manage);
        section.appendChild(keep);
        return section;
      }

      /* The sheet lives on document.body, outside the grid, so a heart save
         (which rebuilds the grid) leaves it open on the same tab. */
      var quick = null;
      function openQuickView(item, opener) {
        if (!live()) return;
        if (!productJsonPath(item) || !doc.body) return;
        if (!quick) quick = createQuickView();
        quick.open(item, opener);
      }
      function createQuickView() {
        var layer = el('div', 'fb-wishlist__sheet');
        layer.hidden = true;
        layer.setAttribute('role', 'dialog');
        layer.setAttribute('aria-modal', 'true');
        layer.setAttribute('aria-labelledby', 'fb-wishlist-sheet-title');
        var panel = el('div', 'fb-wishlist__sheet-panel');
        panel.setAttribute('role', 'document');
        var close = button('', 'fb-wishlist__sheet-close', closeQuick);
        close.setAttribute('aria-label', 'Close');
        close.appendChild(closeIcon());
        var heading = el('div', 'fb-wishlist__sheet-heading');
        var title = el('h2', 'fb-wishlist__sheet-title', '');
        title.id = 'fb-wishlist-sheet-title';
        var titleHeartSlot = el('div', 'fb-wishlist__sheet-title-heart');
        heading.appendChild(title);
        heading.appendChild(titleHeartSlot);
        var priceEl = el('p', 'fb-wishlist__sheet-price');
        var photos = el('div', 'fb-wishlist__sheet-photos');
        var gallery = el('div', 'fb-wishlist__sheet-images');
        var photoHeartSlot = el('div', 'fb-wishlist__sheet-photo-heart');
        photos.appendChild(gallery);
        photos.appendChild(photoHeartSlot);
        var status = el('p', 'fb-wishlist__sheet-status');
        status.setAttribute('role', 'status');
        var description = el('div', 'fb-wishlist__sheet-description');
        panel.appendChild(close);
        panel.appendChild(heading);
        panel.appendChild(priceEl);
        panel.appendChild(photos);
        panel.appendChild(status);
        panel.appendChild(description);
        layer.appendChild(panel);
        panel.addEventListener('click', function (event) { event.stopPropagation(); });
        layer.addEventListener('click', function (event) { if (event.target === layer) closeQuick(); });
        layer.addEventListener('touchmove', function (event) { if (event.target === layer) event.preventDefault(); }, { passive: false });
        doc.body.appendChild(layer);
        doc.addEventListener('keydown', onKey);

        var generation = 0;
        var locked = null;
        var inerted = [];
        var opener = null;
        var current = null;

        function focusable(node) {
          var found = node.querySelectorAll('button, [href]');
          var out = [];
          for (var i = 0; i < found.length; i += 1) {
            if (!found[i].hasAttribute('disabled')) out.push(found[i]);
          }
          return out;
        }
        function onKey(event) {
          if (layer.hidden) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            closeQuick();
            return;
          }
          if (event.key !== 'Tab') return;
          var nodes = focusable(panel);
          if (!nodes.length) return;
          var first = nodes[0];
          var last = nodes[nodes.length - 1];
          var active = doc.activeElement;
          if (event.shiftKey && (active === first || !panel.contains(active))) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && (active === last || !panel.contains(active))) {
            event.preventDefault();
            first.focus();
          }
        }
        function lockScroll() {
          if (locked) return;
          var scrolling = root.scrollY || root.pageYOffset || 0;
          var body = doc.body;
          function remembered(value) { return value == null ? '' : String(value); }
          locked = {
            y: scrolling,
            position: remembered(body.style.position),
            top: remembered(body.style.top),
            left: remembered(body.style.left),
            right: remembered(body.style.right),
            width: remembered(body.style.width),
            overflow: remembered(doc.documentElement.style.overflow)
          };
          body.style.position = 'fixed';
          body.style.top = '-' + scrolling + 'px';
          body.style.left = '0';
          body.style.right = '0';
          body.style.width = '100%';
          doc.documentElement.style.overflow = 'hidden';
        }
        function unlockScroll() {
          if (!locked) return;
          var body = doc.body;
          var y = locked.y;
          body.style.position = locked.position;
          body.style.top = locked.top;
          body.style.left = locked.left;
          body.style.right = locked.right;
          body.style.width = locked.width;
          doc.documentElement.style.overflow = locked.overflow;
          locked = null;
          if (typeof root.scrollTo === 'function') root.scrollTo(0, y);
        }
        function setInert(on) {
          var children = doc.body.children;
          if (on) {
            for (var i = 0; i < children.length; i += 1) {
              var child = children[i];
              if (child === layer || child.hasAttribute('inert')) continue;
              child.setAttribute('inert', '');
              child.inert = true;
              inerted.push(child);
            }
          } else {
            inerted.forEach(function (child) { child.removeAttribute('inert'); child.inert = false; });
            inerted = [];
          }
        }
        function closeQuick() {
          if (layer.hidden) return;
          generation += 1;
          layer.hidden = true;
          setInert(false);
          unlockScroll();
          var handle = current && current.handle;
          var returnTo = opener;
          current = null;
          opener = null;
          if (handle && /^[a-z0-9][a-z0-9-]*$/.test(handle)) {
            var fresh = page.querySelector('[data-wishlist-handle="' + handle + '"]');
            if (fresh) returnTo = fresh;
          }
          if (!returnTo || !page.contains(returnTo)) {
            var tabs = page.querySelectorAll('.fb-wishlist__tab');
            returnTo = mount;
            for (var t = 0; t < tabs.length; t += 1) {
              if (tabs[t].getAttribute('aria-current') === 'page') returnTo = tabs[t];
            }
          }
          if (returnTo && returnTo.focus) returnTo.focus();
        }
        function makeHeart(item) {
          var pressed = state.loved.has(item.handle);
          var heart = button('', 'fb-wishlist__sheet-heart', function () {
            toggle(item, heart.getAttribute('aria-pressed') !== 'true');
          });
          heart.setAttribute('aria-label', 'Love ' + item.title);
          heart.setAttribute('aria-pressed', pressed ? 'true' : 'false');
          heart.appendChild(heartIcon());
          var path = heart.querySelector('path');
          if (path) {
            path.setAttribute('fill', pressed ? '#c23b3b' : 'none');
            path.setAttribute('stroke', pressed ? '#c23b3b' : '#000');
          }
          return heart;
        }
        function paintHeart(item) {
          var focusTitle = doc.activeElement && titleHeartSlot.contains(doc.activeElement);
          var focusPhoto = doc.activeElement && photoHeartSlot.contains(doc.activeElement);
          titleHeartSlot.textContent = '';
          photoHeartSlot.textContent = '';
          var titleHeart = makeHeart(item);
          var photoHeart = makeHeart(item);
          titleHeartSlot.appendChild(titleHeart);
          photoHeartSlot.appendChild(photoHeart);
          if (focusTitle) titleHeart.focus();
          else if (focusPhoto) photoHeart.focus();
        }
        function showCatalogue(item) {
          title.textContent = item.title;
          priceEl.textContent = 'From ' + price(item.priceCents);
          gallery.textContent = '';
          gallery.setAttribute('aria-label', 'Photographs of ' + item.title);
          var image = el('img');
          image.src = sizedImage(item.image, 800);
          image.alt = item.imageAlt || item.title;
          gallery.appendChild(image);
          description.textContent = typeof item.description === 'string' ? item.description.trim() : '';
          status.textContent = description.textContent ? '' : 'Loading the description…';
          paintHeart(item);
        }
        function showProduct(item, details) {
          if (details.title) title.textContent = details.title;
          if (details.priceLabel) priceEl.textContent = details.priceLabel;
          if (details.images.length) {
            gallery.textContent = '';
            details.images.forEach(function (image) {
              var img = el('img');
              img.src = sizedImage(image.src, 800);
              img.alt = image.alt || details.title || item.title;
              gallery.appendChild(img);
            });
          }
          description.textContent = details.description;
          status.textContent = details.description ? '' : 'There’s no description for this bouquet.';
        }
        function open(item, from) {
          if (!live()) return;
          var path = productJsonPath(item);
          if (!path) return;
          current = item;
          opener = from;
          var ticket = generation + 1;
          generation = ticket;
          showCatalogue(item);
          layer.hidden = false;
          lockScroll();
          setInert(true);
          close.focus();
          if (typeof root.fetch !== 'function') {
            status.textContent = description.textContent ? '' : 'The description is unavailable just now.';
            return;
          }
          root.fetch(path, { headers: { Accept: 'application/json' } }).then(function (response) {
            if (!response || !response.ok) throw new Error('status');
            return response.json();
          }).then(function (data) {
            if (ticket !== generation || layer.hidden) return;
            var details = productDetails(data, item.handle);
            if (!details) throw new Error('shape');
            showProduct(item, details);
          }).catch(function () {
            if (ticket !== generation || layer.hidden) return;
            status.textContent = description.textContent ? '' : 'The description is unavailable just now. Try again.';
          });
        }
        return {
          open: open,
          dispose: function () { closeQuick(); generation += 1; doc.removeEventListener('keydown', onKey); if (layer.parentElement) layer.parentElement.removeChild(layer); },
          sync: function () { if (current && !layer.hidden) paintHeart(current); }
        };
      }

      function render() {
        if (!live()) return;
        var oldAbout = mount.querySelector('[data-wishlist-about]');
        if (oldAbout) {
          state.aboutOpen = oldAbout.open;
          var liveDay = oldAbout.querySelector('[data-wishlist-day]');
          var liveMonth = oldAbout.querySelector('[data-wishlist-month]');
          if (liveDay && liveMonth) {
            var prior = state.detailsDraft || {};
            var dayText = String(liveDay.value || '');
            var monthText = liveMonth.value == null ? '' : String(liveMonth.value);
            var liveName = oldAbout.querySelector('input');
            var liveNotes = oldAbout.querySelector('textarea');
            state.detailsDraft = {
              name: liveName ? liveName.value : prior.name,
              notes: liveNotes ? liveNotes.value : prior.notes,
              birthday: (dayText || monthText) ? { dayText: dayText, monthText: monthText, day: /^\d{1,2}$/.test(dayText) ? Number(dayText) : null, month: /^\d{1,2}$/.test(monthText) ? Number(monthText) : null } : null,
              notesVersion: prior.notesVersion != null ? prior.notesVersion : state.list.notesVersion
            };
          }
        }
        var previousFocus = doc.activeElement, keepPreferenceFocus = state.preferenceMount && state.preferenceMount.contains && state.preferenceMount.contains(previousFocus);
        mount.textContent = '';
        mount.appendChild(tabs());
        if (state.status) mount.appendChild(message(state.status));
        if (state.intentDraft) mount.appendChild(el('p', 'fb-wishlist__hint', 'Your earlier choice: ' + state.intentDraft));
        if (state.intentConflict) mount.appendChild(button('Reload latest list', 'fb-wishlist__button', reloadItems));
        mount.appendChild(state.tab === 'browse' ? browse() : yourList());
        if (state.tab === 'browse' && state.loved.size) {
          var bar = el('div', 'fb-wishlist__bar');
          bar.appendChild(el('span', '', '♥ ' + state.loved.size + ' loved'));
          bar.appendChild(button('Your list', 'fb-wishlist__button', function () { state.tab = 'list'; render(); mount.scrollIntoView({ block: 'start' }); }));
          mount.appendChild(bar);
        }
        if (state.preferenceMount && state.preferenceMount.isConnected && !state.preferenceUI) state.preferenceUI = root.FBPersonPreferences.mount(state.preferenceMount, viewApi, { path: '/wishlist/me/preferences', source: 'recipient', title: 'Likes and avoidances', visibility: 'These words and preferences go with the list you share. Only you can edit them.', onSnapshot: function (snapshot) { if (snapshot.notesText === (state.list.notes || '')) state.list.notesVersion = snapshot.notesVersion; } });
        if (keepPreferenceFocus && previousFocus && previousFocus.isConnected) previousFocus.focus();
        if (quick) quick.sync();
      }
      render();
      var resized = null;
      function onResize() { clearTimeout(resized); resized = setTimeout(render, 200); }
      root.addEventListener('resize', onResize);
      disposeOwnerView = function () {
        clearTimeout(resized);
        root.removeEventListener('resize', onResize);
        if (quick) quick.dispose();
        if (state.preferenceUI && state.preferenceUI.destroy) state.preferenceUI.destroy();
      };
    }

    /* ---------- a list someone shared ---------- */
    async function sharedView(token) {
      var generation = ++viewGeneration;
      var data;
      try { data = await api.request('/wishlist/shared/' + token); }
      catch (cause) {
        if (generation !== viewGeneration) return;
        hero.querySelector('.fb-wishlist__title').textContent = 'We couldn’t find that wish list.';
        hero.querySelector('.fb-wishlist__lead').textContent = 'Ask for the link again, or make your own.';
        mount.textContent = '';
        var own = el('a', 'fb-wishlist__button', 'Make my wish list');
        own.href = root.location.pathname;
        mount.appendChild(own);
        return;
      }
      if (generation !== viewGeneration) return;
      var whose = data.name === 'Their' ? 'Their' : possessive(data.name);
      hero.querySelector('.fb-wishlist__title').textContent = whose + ' wish list.';
      hero.querySelector('.fb-wishlist__lead').textContent = data.products.length
        ? 'Their wishes are gifts they’d like. Their favourites are things they like.'
        : 'No current wishes or favourites are available. Their words are below.';
      mount.textContent = '';
      if (data.notes) {
        var quote = el('blockquote', 'fb-wishlist__quote', '“' + data.notes + '”');
        mount.appendChild(quote);
      }
      mount.appendChild(remember(token, data));
      if (data.products.length) mount.appendChild(grid(data.products.slice().sort(function (a, b) { return Number(b.evidence && b.evidence.kind === 'recipient_wishlist') - Number(a.evidence && a.evidence.kind === 'recipient_wishlist'); }), whose + ' wishes and favourites', { href: function (item) { return productHref(item.url); } }));
      var mine = el('p', 'fb-wishlist__hint');
      var make = el('a', '', 'Make your own wish list');
      make.href = root.location.pathname;
      mine.appendChild(make);
      mount.appendChild(mine);
    }

    function remember(token, data) {
      var panel = el('section', 'fb-wishlist__panel');
      var name = data.name === 'Their' ? '' : data.name;
      panel.appendChild(el('h2', 'fb-wishlist__heading', name ? 'Remember ' + possessive(name) + ' birthday' : 'Remember their birthday'));
      if (data.remembered) {
        panel.appendChild(el('p', 'fb-wishlist__hint', (name || 'They') + ' is in your reminders, with this list on their page.'));
        if (data.remembered.occasionId) panel.appendChild(personLink(data.remembered.occasionId));
        return panel;
      }
      panel.appendChild(el('p', 'fb-wishlist__hint', 'We’ll remind you before the day, and their picks lead their shop page so the gift is a sure thing.'));
      var who = input('text', name, { autocomplete: 'off', maxlength: '80' });
      panel.appendChild(field('Their name', who));
      var birthday = birthdayInputs(data.birthday);
      panel.appendChild(birthday.row);
      var status = message('');
      var steps = el('div', 'fb-wishlist__steps');
      panel.appendChild(steps);
      panel.appendChild(status);

      function done(occasion) {
        panel.textContent = '';
        panel.appendChild(el('h2', 'fb-wishlist__heading', (who.value.trim() || 'They') + ' is in your reminders.'));
        panel.appendChild(el('p', 'fb-wishlist__hint', 'Their picks lead their shop page, and we’ll remind you before the day.'));
        if (occasion && occasion.id) panel.appendChild(personLink(occasion.id));
      }
      async function link(occasion) {
        await api.request('/wishlist/shared/' + token + '/add', { method: 'POST', body: { friendId: occasion.friendId } });
        done(occasion);
      }
      var picked = null;
      function draft() { return picked; }

      function remindersChanged() {
        try { api.clearMe(); } catch (_) {}
        try {
          if (!root.document || typeof root.CustomEvent !== 'function' || typeof root.document.dispatchEvent !== 'function') return;
          root.document.dispatchEvent(new root.CustomEvent('fb-reminders:changed'));
        } catch (_) {}
      }

      async function asMember() {
        try {
          var created = await api.createOccasion(Object.assign(draft(), { source: 'wishlist' }));
          remindersChanged();
          await link(created.occasion);
        } catch (cause) {
          var existing = cause && cause.code === 'DUPLICATE' && cause.payload && cause.payload.existing;
          if (!existing) { status.textContent = errorText(cause, 'That didn’t save. Try again.'); return; }
          status.textContent = 'You already have someone called ' + existing.name + '.';
          steps.textContent = '';
          steps.appendChild(button('Add the list to my ' + existing.name, 'fb-wishlist__button', function () {
            link(existing).catch(function (failure) { status.textContent = errorText(failure, 'That didn’t save. Try again.'); });
          }));
        }
      }

      function signIn() {
        steps.textContent = '';
        steps.appendChild(el('p', 'fb-wishlist__hint', 'Your email saves the reminder. We’ll send a code to confirm it.'));
        var email = input('email', '', { autocomplete: 'email', inputmode: 'email' });
        steps.appendChild(field('Your email', email));
        steps.appendChild(button('Send me a code', 'fb-wishlist__button', async function () {
          status.textContent = '';
          try { await api.requestEmailCode(email.value.trim()); }
          catch (cause) { status.textContent = errorText(cause, 'We couldn’t send a code. Try again.'); return; }
          steps.textContent = '';
          var code = input('text', '', { inputmode: 'numeric', autocomplete: 'one-time-code', maxlength: '6' });
          steps.appendChild(field('The 6-digit code we sent to ' + email.value.trim(), code));
          steps.appendChild(button('Confirm', 'fb-wishlist__button', async function () {
            status.textContent = '';
            try {
              var verified = await api.verifyEmailCode({ email: email.value.trim(), code: code.value.trim(), draft: { people: [draft()] } });
              remindersChanged();
              var saved = verified.saved && verified.saved[0];
              if (saved && saved.friendId) await link(saved);
              else await asMember();
            } catch (cause) { status.textContent = errorText(cause, 'That code didn’t work. Try again.'); }
          }));
        }));
      }

      steps.appendChild(button('Add to my reminders', 'fb-wishlist__button', function () {
        status.textContent = '';
        if (!who.value.trim()) { status.textContent = 'Add their name.'; return; }
        birthday.commit(function (date) {
          if (!date.ok) return;
          picked = { name: who.value.trim(), type: 'BIRTHDAY', month: date.month, day: date.day };
          (async function () {
            var signedIn = false;
            try { signedIn = !!(await api.me({ force: true })).signedIn; } catch (_) {}
            if (signedIn) await asMember(); else signIn();
          })();
        });
      }));
      return panel;
    }

    function personLink(occasionId) {
      var open = el('a', 'fb-wishlist__button', 'Open their page');
      open.href = '/pages/reminders?reminder_view=person&id=' + encodeURIComponent(occasionId);
      return open;
    }

    root.document.addEventListener('fb-wishlist:recovered', function () { ownerView(); });
    var recovery = page.querySelector('[data-wishlist-recovery]');
    var query = new root.URLSearchParams(root.location.search);
    if (recovery && (query.has('invite') || query.has('recover'))) recovery.open = true;
    var token = shareToken(root.location.search);
    if (token) sharedView(token); else ownerView();
  }

  return { storefrontShareUrl: storefrontShareUrl, start: start, masonry: masonry, sizedImage: sizedImage, possessive: possessive, shareToken: shareToken, productHref: productHref, catalogueHref: catalogueHref, productJsonPath: productJsonPath, descriptionText: descriptionText, productDetails: productDetails, price: price, errorText: errorText, PICKER_COMMIT_MS: PICKER_COMMIT_MS };
});
